/**
 * Camp-pickup menu — the pure intent builder (v1 T1).
 *
 * Returns state-gated descriptors only: no seams, no handles. Adding a
 * menu item = one descriptor here + one adapter arm in CampMenu. The
 * arrivalState gating matrix lives in the unit test next door.
 */
import type { CampMenuContext, CampMenuIntent, CampArrival } from './types';

const ON = (s: CampArrival, set: CampArrival[]) => set.includes(s);

export function buildCampMenuItems(ctx: CampMenuContext): CampMenuIntent[] {
  const s = ctx.arrivalState;
  const out: CampMenuIntent[] = [];
  // FOCUS
  out.push({ id: 'find', label: 'Find them in the trail-log', group: 'focus' });
  out.push({ id: 'peek_brief', label: 'Peek their brief', group: 'focus' });
  // P3 SP2 — lens drive. Offered in ALL arrival states (focusing history is
  // legitimate). pin_trail is dead without a stamped trail to pin.
  out.push({ id: 'focus_persona', label: 'Focus on them', group: 'focus' });
  out.push({ id: 'pin_trail', label: 'Pin this trail', group: 'focus', disabled: ctx.trailId == null });
  if (ON(s, ['pending'])) out.push({ id: 'pending_status', label: `· ${ctx.personaName} is reading the trail…`, group: 'focus', disabled: true });
  // MANAGE
  if (ctx.canEditHill && ON(s, ['standby', 'resolved'])) out.push({ id: 'set_goal', label: "Set this companion's goal", group: 'manage' });
  // Shared spines P2 — second resident onto THIS trail (gated propose path).
  if (ctx.canInvite && ON(s, ['standby', 'resolved'])) out.push({ id: 'invite_here', label: 'Invite another companion here', group: 'manage', disabled: ctx.trailId == null });
  // §3 mid-spine fork (camp-root): branch a new path / regenerate from this camp.
  if (ON(s, ['standby', 'resolved'])) {
    out.push({ id: 'new_path', label: 'New path from here', group: 'manage' });
    out.push({ id: 're_roll', label: 'Re-roll from here', group: 'manage' });
  }
  if (ON(s, ['resolved'])) out.push({ id: 'fold_back', label: 'Fold back', group: 'manage' });
  if (ON(s, ['standby', 'resolved', 'failed'])) out.push({ id: 'strike_camp', label: 'Strike camp', group: 'manage', danger: true });
  return out;
}
